import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import CrossIcon from "../../resources/icons/x-close.svg";
import CfLoader from "../CfLoader/CfLoader";
import { imgRegex, urlRegex } from "../../configs/App.Regex";
import { useTranslation } from "react-i18next";

const CredentialPreviewModal = (props) => {
  const { t } = useTranslation();

  const { transaction_id, svg_url, openCloseModal, isOpen } = props;
  const [currentImg, setCurrentImg] = useState(null);
  const [imageLoadError, setImageLoadError] = useState(false);
  const [imgUrlError, setImgUrlError] = useState(false);

  const ImageLoading = (
    <svg width="32rem" height="18.875rem" xmlns="http://www.w3.org/2000/svg">
      <rect width="100%" height="100%" fill="#f0f0f0" />
      <foreignObject
        x="91%"
        y="91%"
        width="200"
        height="200"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <div xmlns="http://www.w3.org/1999/xhtml">
          <CfLoader />
        </div>
      </foreignObject>
    </svg>
  );

  useEffect(() => {
    setImgUrlError(false);
    if (svg_url) {
      fetch(svg_url)
        .then((res) => {
          if (!res.ok) {
            throw new Error(t("transaction:network_response_error"));
          }
          return res.blob();
        })
        .then((blob) => {
          const url = URL.createObjectURL(blob);
          setCurrentImg(url);
          setImageLoadError(false);
        })
        .catch((error) => {
          console.error(error);
          setImageLoadError(true);
        });
    } else {
      setCurrentImg();
      setImageLoadError(true);
      setImgUrlError(true);
    }
  }, [svg_url]);

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => openCloseModal(false)}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 top-20 bg-black/30  backdrop-blur-sm " />
        </Transition.Child>

        <div className="fixed inset-0 top-20 overflow-y-auto px-4 md:px-0 max-h-full">
          <div className="flex items-center min-h-full justify-center text-center ">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel id="credential-preview-modal" className="w-full max-w-lg max-h-[85vh] transform overflow-x-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all overflow-y-auto">
                <div className="flex items-center justify-between py-[1.313rem] px-8 font-medium">
                  <p>{t("transaction:verification_report")}</p>
                  <div>
                    <img
                      id="credential-preview-modal-close-button"
                      src={CrossIcon}
                      alt=""
                      onClick={() => openCloseModal(false)}
                      className="w-[1.3rem] cursor-pointer"
                    />
                  </div>
                </div>
                <div>
                  <div className="w-full bg-[#F2F4F7]">
                    {currentImg && !imageLoadError ? (
                      <img
                        src={
                          (currentImg && currentImg.match(urlRegex)) ||
                          (currentImg && currentImg.match(imgRegex))
                            ? currentImg
                            : ""
                        }
                        alt=""
                        className={`w-full px-12 py-[0.875rem]`}
                        onError={() => setImgUrlError(true)}
                      />
                    ) : imageLoadError || imgUrlError ? (
                      <p className="w-full px-12 py-[5rem] text-center text-md">
                        {t("transaction:preview_unavailable")}
                      </p>
                    ) : (
                      ImageLoading
                    )}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default CredentialPreviewModal;
